import { Injectable, Inject } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { DataIdName } from '../entities/global/model';
import { ImplementStatusModalData } from './implement-status-modal';

@Injectable()
export class ImplementStatusModalService {
    constructor(private _http: Http) {

    }
    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
    public saveImplementStatus(data: ImplementStatusModalData): Observable<string> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('implementId', data.implementId.toString());
        params.set('jobsiteId', data.jobsiteId.toString());
        params.set('comment', data.comment.toString());
        params.set('statusId', data.status.toString());
        params.set('repairerId', data.repairerId.toString());
        params.set('workshopId', data.workshopId.toString());
        params.set('date', data.date.toDateString());
        return this._http.get("Api/Implement/ChangeImplementStatus", { search: params }).share().map(
            (response: Response) => <string>response.json()).catch(this.handleError);
    }
}